import Request from '@/utils/request';

export default async (ids) => {
  const params = {
    stids: ids,
  };

  const response = await Request.get('/stations/latest', {
    params,
  });

  return response.data;
};



// WEBPACK FOOTER //
// ./src/api/getStationLatest.js